const isSourceMonitorPath = (path: string) => path === '/news' || path.startsWith('/news/')
const isAdSensitivePath = (path: string) => path === '/' || path.startsWith('/article/')
const isUsAtlasPath = (path: string) => path === '/us' || path.startsWith('/us/')

export function requiresDocumentNavigation(from: string, to: string): boolean {
  const target = new URL(to, 'https://www.omikina.com')
  if (target.origin !== 'https://www.omikina.com') return true
  if (isUsAtlasPath(from) !== isUsAtlasPath(target.pathname)) return true
  return isSourceMonitorPath(from) || isSourceMonitorPath(target.pathname)
    || isAdSensitivePath(from) || isAdSensitivePath(target.pathname)
}
